module.exports = __webpack_public_path__ + "img/start.0fba4f0b.png";